import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from './confirm-dialog/confirm-dialog.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ConfirmDialogModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSnackBarModule,
    OverlayModule
  ],
  declarations: []
})
export class MaterialModule { }
